import SemaphoreHelper from '../../../helpers/semaphore-helper';
import { NgForage } from 'ngforage';
import { CollectionHelper } from '../../../helpers/collection-helper';
import { EXPIRED_OFFLINE_ITEM_REMOVAL_INTERVAL } from '../../../../globals/globals';
import { NgForageTimestampService } from '../../ng-forage/ng-forage-timestamp.service';
import { OfflineStorageObject } from '../../placer-offline-changes/abstract/offline-storage-object';
import { AbstractOfflineStorageAsyncTimestampService } from './abstract-offline-storage-async-timestamp.service';

export abstract class ExpiredOfflineObjectAsyncTimestampRemover<
  ID,
  O extends OfflineStorageObject<ID>
> {
  constructor(
    private offlineStorageService: AbstractOfflineStorageAsyncTimestampService<
      ID,
      O,
      ExpiredOfflineObjectAsyncTimestampRemover<ID, O>
    >,
    private ngForage: NgForage,
    private ngForageTimestampService: NgForageTimestampService
  ) {}

  removeExpiredItems(): void {
    SemaphoreHelper.use(
      this.offlineStorageService.offlineStorageMutex,
      async () => {
        const expiredItems = await this.ngForageTimestampService.getExpiredItems(
          this.offlineStorageService.timestampCollectionKey
        );
        if (CollectionHelper.isPopulated(expiredItems)) {
          const promises = expiredItems.map(async i => {
            const storageKey = this.offlineStorageService.getObjectStorageKey(
              this.offlineStorageService.convertToID(i.key)
            );
            const expiredItem = await this.ngForage.getItem<O>(storageKey);
            if (expiredItem != null) {
              await this.offlineStorageService.cleanupOfflineObject(
                expiredItem
              );
            }
            await this.ngForage.removeItem(storageKey);
          });
          try {
            await Promise.all(promises);
          } catch (err) {
            console.error(err);
          }
          await this.ngForageTimestampService.removeItems(
            this.offlineStorageService.timestampCollectionKey,
            expiredItems.map(i => i.key)
          );
        }
        setTimeout(
          () => this.removeExpiredItems(),
          EXPIRED_OFFLINE_ITEM_REMOVAL_INTERVAL
        );
      }
    );
  }
}
